module.exports = __webpack_public_path__ + "static/media/audio-blue.ccc21865.svg";